import listActions from 'src/modules/position/list/positionListActions';
import PositionService from 'src/modules/position/positionService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'POSITION_DESTROY';

const positionDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: positionDestroyActions.DESTROY_STARTED,
      });

      await PositionService.destroyAll([id]);

      dispatch({
        type: positionDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.position.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/position');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: positionDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: positionDestroyActions.DESTROY_ALL_STARTED,
      });

      await PositionService.destroyAll(ids);

      dispatch({
        type: positionDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.position.destroyAll.success'),
      );

      getHistory().push('/position');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: positionDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default positionDestroyActions;
